import { type BackendSource, getBackendSourceLabel } from "@/lib/backendSource";

export function buildCapabilitiesBootstrapError(error: Error, activeSource: BackendSource): string {
  const backendLabel = getBackendSourceLabel(activeSource);
  return `Could not load your permissions from ${backendLabel}. ${error.message}`;
}
